import {isEmpty, omit, uniq} from 'lodash';
import qs from 'qs';
import {UserType} from 'src/types/enums';

const formatFilters = (filters) => {
  for (const key in filters) {
    switch (key) {
      case 'ccTransferYear':
      case 'hsGraduationYear':
        filters[key] = uniq(filters[key].map((year) => parseInt(year)));
        break;
      case 'followers':
      case 'nonFollowers':
      case 'emailVerified':
        filters[key] = parseInt(filters[key]);
        break;
    }
  }

  return filters;
};

export const collegePortalInitialState = () => {
  const initialState = {
    loading: true,
    collegeProfile: {
      tab: 1,
      userInfo: {
        user: UserType.COLLEGE_PORTAL_USER,
      },
    },
    filters: {},
  };
  const parameters = qs.parse(location.search.substr(1));
  const filters = omit(parameters, 'educationPhase');
  const educationPhase = parameters.educationPhase;

  if (!isEmpty(filters)) {
    initialState.filters = formatFilters(filters);
  }

  if (!isEmpty(educationPhase)) {
    initialState['studentResults'] = {studentSearchType: educationPhase};
  }

  return initialState;
};
